<template>

    <b-card>

        <b-row class="mb-2">

            <b-col lg="4" class="my-1">

                <b-form-select v-model=" status ">

                    <option value="all">All Providers</option>
                    <option value="enrolled">Enrolled Providers</option>
                    <option value="not_enrolled">Never Sent Enrollment</option>
                    <option value="incomplete">Incomplete Enrollment</option>
                </b-form-select>
            </b-col>

            <b-col lg="4" class="my-1" v-if=" carriers.length > 1 ">

                <b-select name="ltc_carrier_id" id="ltc_carrier_id" v-model=" ltc_carrier_id ">

                    <option value="">-- Carrier Block --</option>
                    <option v-for=" carrier in carriers " :key=" carrier.id " :value=" carrier.id ">{{ carrier.initials }}</option>
                </b-select>
            </b-col>

            <b-col lg="4" class="my-1">

                <b-form-select id="activeFilter" v-model=" activeFilter ">

                    <option value="">-- Filter Active/Inactive --</option>
                    <option value="active">Active Providers</option>
                    <option value="inactive">Inactive (Deactivated) Providers</option>
                </b-form-select>
            </b-col>

            <b-col lg="4" class="my-1">

                <b-form-select v-model=" carrierRep " disabled>

                    <option value="">-- Carrier Rep --</option>
                </b-form-select>
            </b-col>
            <b-col lg="4" class="my-1">

                <b-form-select v-model=" claimantFilter " disabled>

                    <option value="">-- Claimant --</option>
                </b-form-select>
            </b-col>
        </b-row>

        <b-row class="mb-4">

            <b-col class="d-flex justify-content-end align-items-center">

                <b-btn variant="info" @click=" loadTable() " :disabled=" loading " class="mr-2">Generate Report</b-btn>
                <b-btn variant="success" @click="exportXls()">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :items=" items "
                :fields=" fields "
                :current-page=" currentPage "
                :per-page=" 0 "
                :sort-by.sync=" sortBy "
                :sort-desc.sync=" sortDesc "
                :busy=" loading "
            >

                <template v-slot:cell(actions)="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->

                    <b-btn size="sm" :href=" '/carriermanager/providers/' + row.item.id " :target=" '_blank' ">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col lg="6">

                <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
            </b-col>
            <b-col lg="6" class="text-right">

                {{ paginationText }}
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

    import FormatsDates from "../../../mixins/FormatsDates";
    import FormatsListData from "../../../mixins/FormatsListData";
    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import FormatsStrings from "../../../mixins/FormatsStrings";
    import PaginatedTable from "../../../mixins/PaginatedTable";

    export default {

        mixins: [ FormatsStrings, FormatsDates, FormatsListData, EnrollmentStatuses, PaginatedTable ],

        props: {

            'carriers': Array,
        },

        data() {

            return {

                ltc_carrier_id   : '',
                activeFilter     : '',
                claimantFilter   : '',
                status           : 'all',
                filter           : '',
                carrierRep       : '',

                baseUrl          : '/carriermanager/providers',

                fields: [

                    {
                        key: 'firstname',
                        label: 'First Name',
                        sortable: true,
                    },
                    {
                        key: 'lastname',
                        label: 'Last Name',
                        sortable: true,
                    },
                    {
                        key: 'email',
                        label: 'Email Address',
                        sortable: true,
                        formatter: this.formatEmail,
                    },
                    {
                        key: 'enrollment_status',
                        label: 'Enrollment Status',
                        sortable: true,
                        formatter: this.formatEnrollmentStatus
                    },
                    {
                        key: 'enrollment_code',
                        label: 'Enrollment Code',
                        sortable: true,
                        formatter: x => { return x ? x : '-' },
                    },
                    {
                        key: 'enrollment_sent_at',
                        label: 'Enrollment Last Sent',
                        sortable: true,
                        formatter: (val) => ! val ? '-' : this.formatDateFromUTC(val),
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },

        computed: {

            appliedFilters(){ return `?ltc_carrier_id=${this.ltc_carrier_id}&active=${this.activeFilter}&status=${this.status}`; },
        },
    }
</script>
